import { CoreTag } from '@featuring-corp/components';
import { disabledAnchor } from '@styles/vanilla-extract/utils';
import { useTranslation } from 'react-i18next';
import React from 'react';

import round from '@utils/round';

import CoreImg from '@shared/CoreImg';

import {
	bodyContainerClass,
	containerClass,
	fullNameClass,
	headerContainerClass,
	imgContainerClass,
	labelClass,
	mainTextClass,
	tagContainerClass,
	textContainerClass,
} from './style.css';
import { getTagColorType } from '../report-profile/util';
import { Link } from 'react-router-dom';
import CustomLink from 'src/shared/custom-link/CustomLink';

export interface RecommendedAccountItemProps {
	categories?: string[];
	src?: string;
	outLink?: string;
	userName?: string;
	fullName?: string;
	followers?: number;
	realFollowers?: number;
	idx?: number;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const RecommendedAccountItem = ({
	categories,
	userName,
	fullName,
	followers,
	realFollowers,
	isLoading,
	isError,
	lackOfPermission,
	idx,
	...props
}: RecommendedAccountItemProps) => {
	const { t } = useTranslation('commonInfReport');
	const available = !isLoading && !isError && !lackOfPermission;
	const outLink = !available ? '' : props.outLink;
	const src = isError
		? 'public/images/report/no-image.png'
		: lackOfPermission
		? `https://source.unsplash.com/random?${idx}`
		: props.src;

	return (
		<CustomLink
			href={outLink ?? ''}
			target="_blank"
			className={disabledAnchor}
			aria-disabled={Boolean(!available || outLink === '')}
		>
			<div className={containerClass}>
				<div className={tagContainerClass}>
					{categories?.map((category, idx) => (
						<CoreTag key={idx} tagType={getTagColorType(category)} text={category} />
					))}
				</div>

				<div className={headerContainerClass}>
					<div className={imgContainerClass}>
						<CoreImg
							object_fit="cover"
							// src={src ?? ''}
							src={
								src ??
								'https://image-dev-backend-v2.featuring.co/influencer/ig/59874425783/image/profile?origin_image_url=https://www.instagram.com/mukdorockga_mukstar/&username=mukdorockga_mukstar'
							}
							alt={'recommended-influencer-profile'}
							is_loading={isLoading}
						/>
					</div>

					<div className={textContainerClass}>
						<p className={mainTextClass}>{userName}</p>
						<p className={fullNameClass}>{fullName}</p>
					</div>
				</div>

				<div className={bodyContainerClass}>
					<div className={textContainerClass}>
						<p className={mainTextClass}>{followers ? round(followers, 'down') : '-'}</p>
						<p className={labelClass}>
							{t('features.report.recommended-account-item.followers')}
						</p>
					</div>
					<div className={textContainerClass}>
						<p className={mainTextClass}>
							{realFollowers ? round(realFollowers, 'down') : '-'}
						</p>
						<p className={labelClass}>
							{t('features.report.recommended-account-item.real-followers')}
						</p>
					</div>
				</div>
			</div>
		</CustomLink>
	);
};

export default RecommendedAccountItem;
